import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from './request/axios'; // 请求封装axios
import api from './request/api'//请求地址
import xlsx from './request/xlsx'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import * as echarts from 'echarts'
import md5 from 'js-md5';
Vue.prototype.$md5 = md5;//md5加密
Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.prototype.$echarts = echarts//统计图
Vue.prototype.$axios = axios;//挂载全局
Vue.prototype.$api = api;//挂载全局
Vue.prototype.$xlsx = xlsx;//挂载全局
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
